import { useTranslation } from 'react-i18next'
import { dataFormat, getDateFormat } from '../../until/constant'
import moment from 'moment'


export const useDateFormat = () => {
  const { i18n } = useTranslation()
    
  const formatDate = (value: string | number, format: keyof typeof dataFormat) => {
    if (!value) return ''
    return moment(value).format(getDateFormat(format, i18n.language))
  }
  
  return { formatDate }
}